import { LenderName } from '@nemuru-eng/js-api-client';

import { COMPANY_CIF_REQUIRED_LENDER_NAMES } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/constants/companyCifRequiredLenderNames';

export const isCompanyCifRequiredLender = (lenderName: LenderName): boolean =>
  COMPANY_CIF_REQUIRED_LENDER_NAMES.includes(lenderName);

export const paymentMethodHasCompanyCifRequiredLender = (
  paymentMethod?: { getAllProviderNames: () => LenderName[] } | null,
): boolean =>
  paymentMethod?.getAllProviderNames().some(isCompanyCifRequiredLender) ?? false;

export const loanApplicationsHaveCompanyCifRequiredLender = (
  loanApplications?: { lenderName?: LenderName | null }[],
): boolean =>
  loanApplications?.some(
    (loanApplication) =>
      loanApplication.lenderName != null && isCompanyCifRequiredLender(loanApplication.lenderName),
  ) ?? false;
